import React from 'react';
import './GeoPermissionModal.css';

function buildModalContent(permissionState) {
  if (permissionState === 'denied') {
    return {
      title: 'Enable Location in Settings',
      body: 'Location access is currently blocked for this site. To use nearby health facilities and local emergency contacts, please enable location permissions in your browser settings.',
      steps: [
        'Open your browser settings',
        'Go to "Site Settings" or "Privacy"',
        'Find "Location"',
        'Allow location access for this website',
      ],
    };
  }

  return {
    title: 'Turn On Location',
    body: 'Location access helps us show nearby health facilities and better local emergency guidance. You can continue without it, but some location-based features may stay unavailable.',
    steps: ['Use your browser prompt to allow location', "If no prompt appears, open this site's location settings"],
  };
}

export default function GeoPermissionModal({ onClose, permissionState = 'denied' }) {
  const content = buildModalContent(permissionState);

  return (
    <div className="geoModal__overlay">
      <div className="geoModal__content">
        <h2>{content.title}</h2>
        <p>{content.body}</p>

        <p className="geoModal__title">How to enable:</p>
        <ul className="geoModal__list">
          {content.steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ul>

        <button type="button" onClick={onClose} className="btn-allow">
          OK
        </button>
      </div>
    </div>
  );
}
